import { TableCell, TableSortLabel } from '@mui/material';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { HeaderItem } from '@/types/headerItem';

interface HeaderCellProps<T> {
  readonly item: HeaderItem<T>;
  readonly sorting: Partial<Record<keyof T, 'asc' | 'desc'>>;

  onClick?(key: keyof T): void;
}

export const HeaderCell = <T,>(props: HeaderCellProps<T>): React.ReactElement => {
  const { item, sorting, onClick: onSort = (): void => {} } = props;

  const tr = useTranslator();
  const onClick = React.useCallback((): void => {
    onSort(item.key);
  }, [item.key, onSort]);

  if (item.sortable) {
    const direction = sorting[item.key];
    const active = !!direction;

    return (
      <TableCell sx={styles.cell}>
        <TableSortLabel direction={direction} active={active} onClick={onClick}>
          <Typography variant="body1" color="text.primary">
            {tr(item.label)}
          </Typography>
        </TableSortLabel>
      </TableCell>
    );
  } else {
    return (
      <TableCell sx={styles.cell}>
        <Typography variant="body1" color="text.primary">
          {tr(item.label)}
        </Typography>
      </TableCell>
    );
  }
};

const styles: Record<string, SystemStyleObject> = {
  cell: {
    '&:first-of-type': {
      pl: 5,
    },
    '&:last-of-type': {
      pr: 5,
    },
  },
};
